import { Injectable } from '@angular/core';
import { BBResponseContainer } from '../common-services/response-container';
import { Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { map, tap, timeout } from 'rxjs/operators';
import { RunDetails } from './model/RunDetails';
import { runProcessdto } from './model/runProcessdto';
import { DilutionPooling } from './model/DilutionPooling';

@Injectable({
  providedIn: 'root'
})
export class RunProcessingService {
  
  constructor(private http: HttpClient) { }
  
  getRunsForLab(labId: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/runProcesses";
    let requestParam = new HttpParams().set('lab', labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }
  
  getRunForLabAndRunId(labId: string, runId: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/runProcess";
    let requestParam = new HttpParams().set('lab', labId).set('run', runId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  saveComment(runID: string, labId: string, comment: any): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/comment/"+runID+"/"+labId;
    return this.http.patch<BBResponseContainer>(url, comment).pipe(timeout(environment.defaultTimeout));
  }

  prepareDataForAnalysis(RunPublishDTO: runProcessdto) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/save";
    return this.http.post<BBResponseContainer>(url, RunPublishDTO).pipe(timeout(environment.defaultTimeout));
  }
  
  downloadSampleSheet(downloadType: string, jsonString: string) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + '/api/excel/download';
    let requestParam = new HttpParams().set('downloadType', downloadType).set('requestParam', jsonString);
    return this.http.get(url, { observe: 'response', responseType: 'blob', params: requestParam }).pipe(
      map((res) => {
        return {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
      })
      );
  }
  
  getListOfLaneView(formData:any): Observable<any> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/laneView";
    return this.http.put<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }

  updateRunStatus(selectedRun: RunDetails) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/status";
    return this.http.put<BBResponseContainer>(url, selectedRun).pipe(timeout(environment.defaultTimeout));
  }

  redoRun(selectedRun: RunDetails) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/sequencing/redo";
    return this.http.put<BBResponseContainer>(url, selectedRun).pipe(timeout(environment.defaultTimeout));
  }

  reRunRun(selectedRun: RunDetails) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/sequencing/rerun";
    return this.http.put<BBResponseContainer>(url, selectedRun).pipe(timeout(environment.defaultTimeout));
  }

  removeLibs(selectedRun: RunDetails) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/sequencing/remove/libs";
    return this.http.put<BBResponseContainer>(url, selectedRun).pipe(timeout(environment.defaultTimeout));
  }

  downloadDilutionPoolingWorkFile(dilutionPooling: DilutionPooling){
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'covid19Batch/downloadDilutionPoolingWorkfile';
    return this.http.post<BBResponseContainer>(url, dilutionPooling).pipe(timeout(environment.defaultTimeout));
  }

  uploadRunFeedbackFile(formData: FormData, runId: string, labId: string) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/feedback/"+runId+"/"+labId;
        return this.http.post<any>(url, formData).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }

  downloadSampleSheetWorkFile(formData:any) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + 'runplan/download/samplesheet';
    return this.http.post<BBResponseContainer>(url,formData).pipe(timeout(environment.defaultTimeout))
  }
}
